// This file was auto-generated by Fern from our API Definition.
import * as FernIr from "../../../index.mjs";
export const WebhookPayload = {
    inlinedPayload: (value) => {
        return Object.assign(Object.assign({}, value), { type: "inlinedPayload", _visit: function (visitor) {
                return FernIr.WebhookPayload._visit(this, visitor);
            } });
    },
    reference: (value) => {
        return Object.assign(Object.assign({}, value), { type: "reference", _visit: function (visitor) {
                return FernIr.WebhookPayload._visit(this, visitor);
            } });
    },
    _visit: (value, visitor) => {
        switch (value.type) {
            case "inlinedPayload":
                return visitor.inlinedPayload(value);
            case "reference":
                return visitor.reference(value);
            default:
                return visitor._other(value);
        }
    },
};
